import React from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import { Container } from 'semantic-ui-react';

import Menu from './components/Menu';
import PlantsList from './components/PlantsList';
import PlantPage from './components/PlantPage';
import useUser from './hooks/useUser';
import Login from './components/Login';


function App() {
  const { user, setUser } = useUser();

  return (
    <Router>
      <Menu user={user} setUser={setUser}/>
      <Container>
        <Switch>
          <Route path="/login">
            <Login setUser={setUser}/>
          </Route>
          <Route path="/plants/:id">
            <PlantPage user={user}/>
          </Route>
          <Route path="/">
            <PlantsList user={user}/>
          </Route>
        </Switch>
      </Container>
    </Router>
  );
}

export default App;
